module.exports = __webpack_public_path__ + "static/media/1.457399a3.jpg";